export const PART_FORMS = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "ClassificationGroup", "userLoginId", "externalId", "name", "partyTypeId", "mainRole", "createdDate", "lastModifiedDate", "partyAction" ]
        } ],
        "columns" : [ {
            "name" : "partyId",
            "title" : "Party ID"
        }, {
            "name" : "ClassificationGroup",
            "title" : "Classification Group"
        }, {
            "name" : "userLoginId",
            "title" : "User Login ID"
        }, {
            "name" : "externalId",
            "title" : "External ID"
        }, {
            "name" : "name",
            "title" : "Name"
        }, {
            "name" : "partyTypeId",
            "title" : "Type"
        }, {
            "name" : "mainRole",
            "title" : "PartyMainRole"
        }, {
            "name" : "createdDate",
            "title" : "Created Date"
        }, {
            "name" : "lastModifiedDate",
            "title" : "Last Modified Date"
        }, {
            "name" : "partyAction",
            "title" : " "
        } ],
        "formName" : "ListCustomers",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "type" : "HYPERLINK",
            "target" : "viewprofile",
            "isSortField" : "Y",
            "width" : "",
            "name" : "partyId",
            "parameterList" : [ {
            "name" : "partyId"
            } ],
            "style" : "",
            "id" : "ListParty_partyId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "event":"view",
            "formData":{
                "formName":"ProductImages",
                "formLocation":"component://kwikstore/widget/ImageManagementForms.xml",
                "listType":"grid",
                "viewIndex":1,
                "endPoint":"viewprofile",
                "link":"/admin/crm/customers/customer/${partyId}"
              }
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "externalId",
            "description" : "",
            "style" : "",
            "id" : "ListParty_externalId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "name",
            "description" : "",
            "style" : "",
            "id" : "ListParty_name",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListParty_partyTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "mainRole",
            "description" : "",
            "style" : "",
            "id" : "ListParty_mainRole",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "createdDate",
            "description" : "",
            "style" : "",
            "id" : "ListParty_createdDate",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "lastModifiedDate",
            "description" : "",
            "style" : "",
            "id" : "ListParty_lastModifiedDate",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, { } ],
        "target" : "expirePartyRate"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "orderName", "statusId", "partyId", "orderDate", "remainingSubTotal", "grandTotal" ]
        } ],
        "columns" : [ {
            "name" : "orderId",
            "title" : "Order ID"
        }, {
            "name" : "orderName",
            "title" : "Order Name"
        }, {
            "name" : "statusId",
            "title" : "Status"
        }, {
            "name" : "partyId",
            "title" : "Party ID"
        }, {
            "name" : "orderDate",
            "title" : "Order Date"
        }, {
            "name" : "remainingSubTotal",
            "title" : "Remaining Sub Total"
        }, {
            "name" : "grandTotal",
            "title" : "Grand Total"
        } ],
        "formName" : "CustomerOrders",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Order ID",
            "type" : "HYPERLINK",
            "target" : "orderview",
            "name" : "orderId",
            "width" : "",
            "parameterList" : [ {
            "name" : "orderId"
            } ],
            "style" : "",
            "id" : "CustomerOrders_orderId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formName":"orderview",
                "formLocation":"component://kwikstore/widget/PartyForms.xml"
            }
        }, {
            "event":"custom",
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderName",
            "description" : "",
            "style" : "",
            "id" : "CustomerOrders_orderName",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "CustomerOrders_statusId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "hyperlink" : {
            "linkStyle" : "smallSubmit",
            "description" : " ",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0",
                "partyId" : "10000"
            },
            "uniqueItemName" : "Modal_2963d8df_9d86_4049_8c34_7570e2be4f7d",
            "target" : "viewprofile",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "Zulu Maiden",
            "style" : "",
            "id" : "CustomerOrders_partyId",
            "title" : "",
            "type" : "HYPERLINK",
            "parameterList" : [ {
                "name" : "partyId"
            } ],
            "imageLocation" : "",
            "event":"edit",
            "formData":{
                "formName":"ProductImages",
                "formLocation":"component://kwikstore/widget/ImageManagementForms.xml",
                "listType":"grid",
                "viewIndex":1,
                "endPoint":"viewprofile",
                "link":"/admin/crm/customers/customer/${partyId}"
              }
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderDate",
            "description" : "",
            "style" : "",
            "id" : "CustomerOrders_orderDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "remainingSubTotal",
            "description" : "",
            "style" : "",
            "id" : "CustomerOrders_remainingSubTotal",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "grandTotal",
            "description" : "",
            "style" : "",
            "id" : "CustomerOrders_grandTotal",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""

    },
    {

        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "quoteTypeId", "partyId", "issueDate", "statusId", "currencyUomId", "productStoreId", "salesChannelEnumId", "validFromDate", "validThruDate", "quoteName", "description" ]
        } ],
        "columns" : [ {
            "name" : "quoteId",
            "title" : "Quote ID"
        }, {
            "name" : "quoteTypeId",
            "title" : "Quote Type ID"
        }, {
            "name" : "partyId",
            "title" : "PartyPartyId"
        }, {
            "name" : "issueDate",
            "title" : "Quote Issue Date"
        }, {
            "name" : "statusId",
            "title" : "Status"
        }, {
            "name" : "currencyUomId",
            "title" : "Currency"
        }, {
            "name" : "productStoreId",
            "title" : "Product Store ID"
        }, {
            "name" : "salesChannelEnumId",
            "title" : "Sales Channel Enum ID"
        }, {
            "name" : "validFromDate",
            "title" : "Valid From Date"
        }, {
            "name" : "validThruDate",
            "title" : "Valid Through Date"
        }, {
            "name" : "quoteName",
            "title" : "Quote Name"
        }, {
            "name" : "description",
            "title" : "Description"
        } ],
        "formName" : "ListCustomerQuotes",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Quote ID",
            "type" : "HYPERLINK",
            "target" : "ViewQuote",
            "name" : "quoteId",
            "width" : "",
            "parameterList" : [ {
            "name" : "quoteId"
            } ],
            "style" : "",
            "id" : "ListQuotes_quoteId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quoteTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListQuotes_quoteTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "ListQuotes_partyId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "issueDate",
            "description" : "",
            "style" : "",
            "id" : "ListQuotes_issueDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "ListQuotes_statusId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "currencyUomId",
            "description" : "",
            "style" : "",
            "id" : "ListQuotes_currencyUomId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productStoreId",
            "description" : "",
            "style" : "",
            "id" : "ListQuotes_productStoreId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "salesChannelEnumId",
            "description" : "",
            "style" : "",
            "id" : "ListQuotes_salesChannelEnumId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "validFromDate",
            "description" : "",
            "style" : "",
            "id" : "ListQuotes_validFromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "validThruDate",
            "description" : "",
            "style" : "",
            "id" : "ListQuotes_validThruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quoteName",
            "description" : "",
            "style" : "",
            "id" : "ListQuotes_quoteName",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ListQuotes_description",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "custRequestTypeId", "productStoreId", "custRequestName", "priority", "custRequestDate", "responseRequiredDate", "fromPartyId", "statusId", "lastModifiedDate", "rejectButton" ]
        } ],
        "columns" : [ {
            "name" : "custRequestId",
            "title" : "Cust Request ID"
        }, {
            "name" : "custRequestTypeId",
            "title" : "Cust Request Type ID"
        }, {
            "name" : "productStoreId",
            "title" : "Product Store ID"
        }, {
            "name" : "custRequestName",
            "title" : "Cust Request Name"
        }, {
            "name" : "priority",
            "title" : "Priority"
        }, {
            "name" : "custRequestDate",
            "title" : "Cust Request Date"
        }, {
            "name" : "responseRequiredDate",
            "title" : "Response Required Date"
        }, {
            "name" : "fromPartyId",
            "title" : "From Party ID"
        }, {
            "name" : "statusId",
            "title" : "Status ID"
        }, {
            "name" : "lastModifiedDate",
            "title" : "Last Modified Date"
        }, {
            "name" : "rejectButton",
            "title" : "Reject"
        } ],
        "formName" : "ListCustomerRequests",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "type" : "HYPERLINK",
            "target" : "ViewRequest",
            "isSortField" : "Y",
            "width" : "",
            "name" : "custRequestId",
            "parameterList" : [ {
            "name" : "custRequestId"
            } ],
            "style" : "",
            "id" : "ListRequestList_custRequestId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "custRequestTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListRequestList_custRequestTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "hyperlink" : {
            "linkStyle" : "",
            "description" : "[]",
            "targetType" : "inter-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_e0fcefac_5cab_48e9_9997_e331759dcaad",
            "target" : "/catalog/control/EditProductStore",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productStoreId",
            "description" : "",
            "style" : "",
            "id" : "ListRequestList_productStoreId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "custRequestName",
            "description" : "",
            "style" : "",
            "id" : "ListRequestList_custRequestName",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "priority",
            "description" : "",
            "style" : "",
            "id" : "ListRequestList_priority",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "custRequestDate",
            "description" : "",
            "style" : "",
            "id" : "ListRequestList_custRequestDate",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "responseRequiredDate",
            "description" : "",
            "style" : "",
            "id" : "ListRequestList_responseRequiredDate",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "hyperlink" : {
            "linkStyle" : "",
            "description" : "[]",
            "targetType" : "inter-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_d2b61669_a829_4b6e_9db5_58969278745d",
            "target" : "/partymgr/control/viewprofile",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "fromPartyId",
            "description" : "",
            "style" : "",
            "id" : "ListRequestList_fromPartyId",
            "type" : "DISPLAY_ENTITY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "ListRequestList_statusId",
            "type" : "DISPLAY_ENTITY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "lastModifiedDate",
            "description" : "",
            "style" : "",
            "id" : "ListRequestList_lastModifiedDate",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Reject",
            "title" : "Reject",
            "type" : "HYPERLINK",
            "target" : "setCustRequestStatus",
            "name" : "rejectButton",
            "width" : "",
            "parameterList" : [ {
            "name" : "custRequestId"
            }, {
            "name" : "statusId",
            "value" : {
                "chars" : "CRQ_REJECTED",
                "hint" : 20,
                "empty" : false,
                "original" : "CRQ_REJECTED"
            }
            } ],
            "style" : "",
            "id" : "ListRequestList_rejectButton",
            "imageTitle" : "",
            "parameterMap" : {
            "statusId" : "CRQ_REJECTED"
            },
            "height" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "quoteId", "quoteId", "quoteTypeId", "partyId", "issueDate", "statusId", "statusId", "statusId", "currencyUomId", "productStoreId", "salesChannelEnumId", "validFromDate", "validThruDate", "quoteName", "description", "submitButton" ]
        } ],
        "formName" : "EditCustomerQuote",
        "altTarget" : [ {
            "useWhen" : "quote==null",
            "targetExdr" : {
            "chars" : "createQuote",
            "hint" : 20,
            "empty" : false,
            "original" : "createQuote"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "quoteId",
            "action" : "",
            "id" : "EditQuote_quoteId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Quote Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditCustomerQuote",
            "options" : [ {
            "description" : "Other",
            "key" : "OTHER_QUOTE"
            }, {
            "description" : "Product",
            "key" : "PRODUCT_QUOTE"
            }, {
            "description" : "Product Purchase",
            "key" : "PURCHASE_QUOTE"
            }, {
            "description" : "Proposal",
            "key" : "PROPOSAL"
            } ],
            "disabled" : "false",
            "id" : "EditQuote_quoteTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "quoteTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditCustomerQuote",
            "id" : "EditQuote_partyId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "partyId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "partyId",
            "style" : "",
            "id" : "EditQuote_partyId",
            "title" : "PartyPartyId",
            "type" : "LOOKUP"
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Quote Issue Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2024-10-01%2012:25:55.36",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditCustomerQuote",
            "timeDropdownParamName" : "issueDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditQuote_issueDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "issueDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Status",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditCustomerQuote",
            "options" : [ {
            "description" : "Created",
            "key" : "QUO_CREATED"
            }, {
            "description" : "Approved",
            "key" : "QUO_APPROVED"
            }, {
            "description" : "Ordered",
            "key" : "QUO_ORDERED"
            }, {
            "description" : "Rejected",
            "key" : "QUO_REJECTED"
            } ],
            "disabled" : "false",
            "id" : "EditQuote_statusId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "statusId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Currency",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditCustomerQuote",
            "options" : [ {
            "description" : "Afghani - AFN",
            "key" : "AFN"
            }, {
            "description" : "Albanian Lek - ALL",
            "key" : "ALL"
            }, {
            "description" : "Algerian Dinar - DZD",
            "key" : "DZD"
            }, {
            "description" : "American Dollar - USD",
            "key" : "USD"
            }, {
            "description" : "Angolan Kwanza - AOA",
            "key" : "AOA"
            }, {
            "description" : "Argentina Peso - ARS",
            "key" : "ARS"
            }, {
            "description" : "Armenian Dram - AMD",
            "key" : "AMD"
            }, {
            "description" : "Aruban Guilder - AWG",
            "key" : "AWG"
            }, {
            "description" : "Australian Dollar - AUD",
            "key" : "AUD"
            }, {
            "description" : "Azerbaijan Manat - AZN",
            "key" : "AZN"
            }, {
            "description" : "Bahaman Dollar - BSD",
            "key" : "BSD"
            }, {
            "description" : "Bahrain Dinar - BHD",
            "key" : "BHD"
            }, {
            "description" : "Bangladesh Taka - BDT",
            "key" : "BDT"
            }, {
            "description" : "Barbados Dollar - BBD",
            "key" : "BBD"
            }, {
            "description" : "Belize Dollar - BZD",
            "key" : "BZD"
            }, {
            "description" : "Belorussian Ruble - BYN",
            "key" : "BYN"
            }, {
            "description" : "Benin C.f.A. Franc - XOF",
            "key" : "XOF"
            }, {
            "description" : "Bermudan Dollar - BMD",
            "key" : "BMD"
            }, {
            "description" : "Bolivian Boliviano - BOB",
            "key" : "BOB"
            }, {
            "description" : "Botswana Pula - BWP",
            "key" : "BWP"
            }, {
            "description" : "Brazilian Real - BRL",
            "key" : "BRL"
            }, {
            "description" : "British Pound - GBP",
            "key" : "GBP"
            }, {
            "description" : "Brunei Dollar - BND",
            "key" : "BND"
            }, {
            "description" : "Bulgarian Lev - BGN",
            "key" : "BGN"
            }, {
            "description" : "Burundi Franc - BIF",
            "key" : "BIF"
            }, {
            "description" : "Cambodian Riel - KHR",
            "key" : "KHR"
            }, {
            "description" : "Canadian Dollar - CAD",
            "key" : "CAD"
            }, {
            "description" : "Cape Verde Escudo - CVE",
            "key" : "CVE"
            }, {
            "description" : "Cayman Dollar - KYD",
            "key" : "KYD"
            }, {
            "description" : "Chilean Peso - CLP",
            "key" : "CLP"
            }, {
            "description" : "China - CNY",
            "key" : "CNY"
            }, {
            "description" : "Colombian Peso - COP",
            "key" : "COP"
            }, {
            "description" : "Comoros Franc - KMF",
            "key" : "KMF"
            }, {
            "description" : "Convertible Marks - BAM",
            "key" : "BAM"
            }, {
            "description" : "Costa Rica Colon - CRC",
            "key" : "CRC"
            }, {
            "description" : "Croatian Kuna - HRK",
            "key" : "HRK"
            }, {
            "description" : "Cuban Peso - CUP",
            "key" : "CUP"
            }, {
            "description" : "Czech Krona - CZK",
            "key" : "CZK"
            }, {
            "description" : "Danish Krone - DKK",
            "key" : "DKK"
            }, {
            "description" : "Djibouti Franc - DJF",
            "key" : "DJF"
            }, {
            "description" : "Dominican Peso - DOP",
            "key" : "DOP"
            }, {
            "description" : "East Carribean Dollar - XCD",
            "key" : "XCD"
            }, {
            "description" : "Egyptian Pound - EGP",
            "key" : "EGP"
            }, {
            "description" : "El Salvador Colon - SVC",
            "key" : "SVC"
            }, {
            "description" : "Ethiopian Birr - ETB",
            "key" : "ETB"
            }, {
            "description" : "Euro - EUR",
            "key" : "EUR"
            }, {
            "description" : "Falkland Pound - FKP",
            "key" : "FKP"
            }, {
            "description" : "Fiji Dollar - FJD",
            "key" : "FJD"
            }, {
            "description" : "Gabon C.f.A Franc - XAF",
            "key" : "XAF"
            }, {
            "description" : "Gambian Dalasi - GMD",
            "key" : "GMD"
            }, {
            "description" : "Ghanian Cedi - GHS",
            "key" : "GHS"
            }, {
            "description" : "Gibraltar Pound - GIP",
            "key" : "GIP"
            }, {
            "description" : "Guatemalan Quedzal - GTQ",
            "key" : "GTQ"
            }, {
            "description" : "Guinea Franc - GNF",
            "key" : "GNF"
            }, {
            "description" : "Guyanese Dollar - GYD",
            "key" : "GYD"
            }, {
            "description" : "Haitian Gourde - HTG",
            "key" : "HTG"
            }, {
            "description" : "Honduran Lempira - HNL",
            "key" : "HNL"
            }, {
            "description" : "Hong Kong Dollar - HKD",
            "key" : "HKD"
            }, {
            "description" : "Hungarian forint - HUF",
            "key" : "HUF"
            }, {
            "description" : "Iceland Krona - ISK",
            "key" : "ISK"
            }, {
            "description" : "Indian Rupee - INR",
            "key" : "INR"
            }, {
            "description" : "Indonesian Rupiah - IDR",
            "key" : "IDR"
            }, {
            "description" : "Iranian Rial - IRR",
            "key" : "IRR"
            }, {
            "description" : "Iraqui Dinar - IQD",
            "key" : "IQD"
            }, {
            "description" : "Jamaican Dollar - JMD",
            "key" : "JMD"
            }, {
            "description" : "Japanese Yen - JPY",
            "key" : "JPY"
            }, {
            "description" : "Jordanian Dinar - JOD",
            "key" : "JOD"
            }, {
            "description" : "Kazakhstani Tenge - KZT",
            "key" : "KZT"
            }, {
            "description" : "Kenyan Shilling - KES",
            "key" : "KES"
            }, {
            "description" : "Kirghizstan Som - KGS",
            "key" : "KGS"
            }, {
            "description" : "Kuwaiti Dinar - KWD",
            "key" : "KWD"
            }, {
            "description" : "Laotian Kip - LAK",
            "key" : "LAK"
            }, {
            "description" : "Lari - GEL",
            "key" : "GEL"
            }, {
            "description" : "Lebanese Pound - LBP",
            "key" : "LBP"
            }, {
            "description" : "Leone - SLL",
            "key" : "SLL"
            }, {
            "description" : "Lesotho Loti - LSL",
            "key" : "LSL"
            }, {
            "description" : "Liberian Dollar - LRD",
            "key" : "LRD"
            }, {
            "description" : "Libyan Dinar - LYD",
            "key" : "LYD"
            }, {
            "description" : "Macao Pataca - MOP",
            "key" : "MOP"
            }, {
            "description" : "Malagascy Ariary - MGA",
            "key" : "MGA"
            }, {
            "description" : "Malawi Kwacha - MWK",
            "key" : "MWK"
            }, {
            "description" : "Malaysian Ringgit - MYR",
            "key" : "MYR"
            }, {
            "description" : "Maldive Rufiyaa - MVR",
            "key" : "MVR"
            }, {
            "description" : "Mauritanian Ouguiya - MRU",
            "key" : "MRU"
            }, {
            "description" : "Mauritius Rupee - MUR",
            "key" : "MUR"
            }, {
            "description" : "Mexican Peso - MXN",
            "key" : "MXN"
            }, {
            "description" : "Moldavian Lei - MDL",
            "key" : "MDL"
            }, {
            "description" : "Mongolian Tugrik - MNT",
            "key" : "MNT"
            }, {
            "description" : "Moroccan Dirham - MAD",
            "key" : "MAD"
            }, {
            "description" : "Mozambique Metical - MZN",
            "key" : "MZN"
            }, {
            "description" : "Nepalese Rupee - NPR",
            "key" : "NPR"
            }, {
            "description" : "New Israeli Shekel - ILS",
            "key" : "ILS"
            }, {
            "description" : "New Taiwan Dollar - TWD",
            "key" : "TWD"
            }, {
            "description" : "New Zaire - ZRN",
            "key" : "ZRN"
            }, {
            "description" : "New Zealand Dollar - NZD",
            "key" : "NZD"
            }, {
            "description" : "Nicaraguan Cordoba - NIO",
            "key" : "NIO"
            }, {
            "description" : "Nigerian Naira - NGN",
            "key" : "NGN"
            }, {
            "description" : "North Korean Won - KPW",
            "key" : "KPW"
            }, {
            "description" : "Norwegian Krone - NOK",
            "key" : "NOK"
            }, {
            "description" : "Omani Rial - OMR",
            "key" : "OMR"
            }, {
            "description" : "Pakistan Rupee - PKR",
            "key" : "PKR"
            }, {
            "description" : "Panamanian Balboa - PAB",
            "key" : "PAB"
            }, {
            "description" : "Papua New Guinea Kina - PGK",
            "key" : "PGK"
            }, {
            "description" : "Paraguayan Guarani - PYG",
            "key" : "PYG"
            }, {
            "description" : "Peruvian Sol - PEN",
            "key" : "PEN"
            }, {
            "description" : "Philippino Peso - PHP",
            "key" : "PHP"
            }, {
            "description" : "Polish Zloty - PLN",
            "key" : "PLN"
            }, {
            "description" : "Qatar Riyal - QAR",
            "key" : "QAR"
            }, {
            "description" : "Romanian Leu - RON",
            "key" : "RON"
            }, {
            "description" : "Russian Rouble - RUB",
            "key" : "RUB"
            }, {
            "description" : "Rwanda Franc - RWF",
            "key" : "RWF"
            }, {
            "description" : "Samoan Tala - WST",
            "key" : "WST"
            }, {
            "description" : "Sao Tome and Principe Dobra - STN",
            "key" : "STN"
            }, {
            "description" : "Saudi Riyal - SAR",
            "key" : "SAR"
            }, {
            "description" : "Seychelles Rupee - SCR",
            "key" : "SCR"
            }, {
            "description" : "Singapore Dollar - SGD",
            "key" : "SGD"
            }, {
            "description" : "Solomon Islands Dollar - SBD",
            "key" : "SBD"
            }, {
            "description" : "Somalian Shilling - SOS",
            "key" : "SOS"
            }, {
            "description" : "South African Rand - ZAR",
            "key" : "ZAR"
            }, {
            "description" : "South Korean Won - KRW",
            "key" : "KRW"
            }, {
            "description" : "South Sudanese Pound - SSP",
            "key" : "SSP"
            }, {
            "description" : "Sri Lankan Rupee - LKR",
            "key" : "LKR"
            }, {
            "description" : "St.Helena Pound - SHP",
            "key" : "SHP"
            }, {
            "description" : "Sudanese Pound - SDG",
            "key" : "SDG"
            }, {
            "description" : "Surinam Dollar - SRD",
            "key" : "SRD"
            }, {
            "description" : "Swaziland Lilangeni - SZL",
            "key" : "SZL"
            }, {
            "description" : "Swedish Krona - SEK",
            "key" : "SEK"
            }, {
            "description" : "Swiss Franc - CHF",
            "key" : "CHF"
            }, {
            "description" : "Syrian Pound - SYP",
            "key" : "SYP"
            }, {
            "description" : "Tadzhikistani Somoni - TJS",
            "key" : "TJS"
            }, {
            "description" : "Tanzanian Shilling - TZS",
            "key" : "TZS"
            }, {
            "description" : "Thailand Baht - THB",
            "key" : "THB"
            }, {
            "description" : "Tongan Pa\\'anga - TOP",
            "key" : "TOP"
            }, {
            "description" : "Trinidad and Tobago Dollar - TTD",
            "key" : "TTD"
            }, {
            "description" : "Tunisian Dinar - TND",
            "key" : "TND"
            }, {
            "description" : "Turkish Lira - TRY",
            "key" : "TRY"
            }, {
            "description" : "Turkmenistani Manat - TMT",
            "key" : "TMT"
            }, {
            "description" : "Ugandan Shilling - UGX",
            "key" : "UGX"
            }, {
            "description" : "Ukrainian Hryvnia - UAH",
            "key" : "UAH"
            }, {
            "description" : "United Arab Emirates Dirham - AED",
            "key" : "AED"
            }, {
            "description" : "Uruguay - UYU",
            "key" : "UYU"
            }, {
            "description" : "Uruguay Peso en Unidades Indexadas (UI) - UYI",
            "key" : "UYI"
            }, {
            "description" : "Vanuatu Vatu - VUV",
            "key" : "VUV"
            }, {
            "description" : "Venezuelan Bolívar Soberano - VES",
            "key" : "VES"
            }, {
            "description" : "Vietnamese Dong - VND",
            "key" : "VND"
            }, {
            "description" : "West Indian Guilder - ANG",
            "key" : "ANG"
            }, {
            "description" : "Yemeni Ryal - YER",
            "key" : "YER"
            }, {
            "description" : "Zambian Kwacha - ZMW",
            "key" : "ZMW"
            }, {
            "description" : "Zimbabwean Dollar - ZWL",
            "key" : "ZWL"
            } ],
            "disabled" : "false",
            "id" : "EditQuote_currencyUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "currencyUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Store",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditCustomerQuote",
            "options" : [ {
            "description" : "Flowers All Over",
            "key" : "10140"
            }, {
            "description" : "High Five",
            "key" : "10170"
            }, {
            "description" : "Kwikstore",
            "key" : "KWIKSTORE"
            }, {
            "description" : "Louis Stores",
            "key" : "10131"
            }, {
            "description" : "Loving This",
            "key" : "10180"
            }, {
            "description" : "Lucky Stores",
            "key" : "10181"
            }, {
            "description" : "My Store",
            "key" : "10150"
            }, {
            "description" : "OFBiz E-Commerce Store",
            "key" : "9000"
            }, {
            "description" : "OFBiz Physical Retail Store",
            "key" : "9100"
            }, {
            "description" : "Open Travel system Demo Site",
            "key" : "RentalStore"
            }, {
            "description" : "Revolution",
            "key" : "10197"
            }, {
            "description" : "Some Name",
            "key" : "10182"
            }, {
            "description" : "Some Name",
            "key" : "10185"
            }, {
            "description" : "Some Name",
            "key" : "10186"
            }, {
            "description" : "Some Name",
            "key" : "10190"
            }, {
            "description" : "Some Name",
            "key" : "10206"
            }, {
            "description" : "Some Name",
            "key" : "10209"
            }, {
            "description" : "Some Name",
            "key" : "10220"
            }, {
            "description" : "Some Store",
            "key" : "10130"
            }, {
            "description" : "Some Store",
            "key" : "10205"
            }, {
            "description" : "Some Store",
            "key" : "10207"
            }, {
            "description" : "Some Store",
            "key" : "10221"
            }, {
            "description" : "State Capture",
            "key" : "10196"
            }, {
            "description" : "Store of lies",
            "key" : "10195"
            }, {
            "description" : "Test Store 1",
            "key" : "10184"
            }, {
            "description" : "Test Store 1",
            "key" : "10191"
            }, {
            "description" : "Test Store 1",
            "key" : "10192"
            }, {
            "description" : "Test Store 1",
            "key" : "10193"
            }, {
            "description" : "Test Store 1",
            "key" : "10199"
            }, {
            "description" : "Test Store 1",
            "key" : "10203"
            }, {
            "description" : "Test Store 1",
            "key" : "10204"
            }, {
            "description" : "Test Store 1",
            "key" : "10210"
            }, {
            "description" : "Test Store 2",
            "key" : "10020"
            }, {
            "description" : "Test Store 2",
            "key" : "10183"
            }, {
            "description" : "Test Store 2",
            "key" : "10187"
            }, {
            "description" : "Test Store 2",
            "key" : "10200"
            }, {
            "description" : "Test Store 2",
            "key" : "10202"
            }, {
            "description" : "Test Store 3",
            "key" : "10030"
            }, {
            "description" : "Test Store 4",
            "key" : "10040"
            }, {
            "description" : "Test Store 5",
            "key" : "10050"
            }, {
            "description" : "Test Store 6",
            "key" : "10060"
            }, {
            "description" : "Test Store 6",
            "key" : "10070"
            }, {
            "description" : "Test Store 6",
            "key" : "10080"
            }, {
            "description" : "Test Store 6",
            "key" : "10090"
            }, {
            "description" : "Test Store 6",
            "key" : "10100"
            }, {
            "description" : "Test Store 6",
            "key" : "10110"
            }, {
            "description" : "Test Store 6",
            "key" : "10120"
            }, {
            "description" : "Test Store 6",
            "key" : "10188"
            }, {
            "description" : "Test Store 6",
            "key" : "10189"
            }, {
            "description" : "Test Store 6",
            "key" : "10198"
            }, {
            "description" : "Test Store 6",
            "key" : "10201"
            }, {
            "description" : "Test Store 6",
            "key" : "10208"
            }, {
            "description" : "This Store",
            "key" : "10160"
            }, {
            "description" : "Zulu Twak",
            "key" : "10194"
            } ],
            "disabled" : "false",
            "id" : "EditQuote_productStoreId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productStoreId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Sales Channel",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditCustomerQuote",
            "options" : [ {
            "description" : "Web Channel",
            "key" : "WEB_SALES_CHANNEL"
            }, {
            "description" : "Fax Channel",
            "key" : "FAX_SALES_CHANNEL"
            }, {
            "description" : "Phone Channel",
            "key" : "PHONE_SALES_CHANNEL"
            }, {
            "description" : "E-Mail Channel",
            "key" : "EMAIL_SALES_CHANNEL"
            }, {
            "description" : "Snail Mail Channel",
            "key" : "SNAIL_SALES_CHANNEL"
            }, {
            "description" : "Affiliate Channel",
            "key" : "AFFIL_SALES_CHANNEL"
            }, {
            "description" : "eBay Channel",
            "key" : "EBAY_SALES_CHANNEL"
            }, {
            "description" : "POS Channel",
            "key" : "POS_SALES_CHANNEL"
            }, {
            "description" : "Unknown Channel",
            "key" : "UNKNWN_SALES_CHANNEL"
            } ],
            "disabled" : "false",
            "id" : "EditQuote_salesChannelEnumId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "salesChannelEnumId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Valid From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2024-10-01%2012:25:55.384",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditCustomerQuote",
            "timeDropdownParamName" : "validFromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditQuote_validFromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "validFromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Valid Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2024-10-01%2012:25:55.384",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditCustomerQuote",
            "timeDropdownParamName" : "validThruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditQuote_validThruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "validThruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Quote Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "quoteName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditQuote_quoteName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditQuote_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditCustomerQuote",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditQuote_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Submit",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateQuote"

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "accountLimit", "description", "fromDate", "thruDate" ]
        } ],
        "columns" : [ {
            "name" : "billingAccountId",
            "title" : "Billing Account ID"
        }, {
            "name" : "accountLimit",
            "title" : "Account Limit"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        } ],
        "formName" : "ListCustomerBillingAccounts",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Billing Account ID",
            "type" : "HYPERLINK",
            "target" : "EditBillingAccount",
            "name" : "billingAccountId",
            "width" : "",
            "parameterList" : [ {
            "name" : "billingAccountId"
            } ],
            "style" : "",
            "id" : "ListBillingAccounts_billingAccountId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "accountLimit",
            "description" : "",
            "style" : "",
            "id" : "ListBillingAccounts_accountLimit",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ListBillingAccounts_description",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListBillingAccounts_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListBillingAccounts_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "finAccountTypeId", "statusId", "finAccountName", "finAccountCode", "finAccountPin", "currencyUomId", "organizationPartyId", "ownerPartyId", "postToGlAccountId", "fromDate", "thruDate", "isRefundable", "replenishPaymentId", "replenishLevel", "actualBalance", "availableBalance", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "finAccountId",
            "title" : "Fin Account ID"
        }, {
            "name" : "finAccountTypeId",
            "title" : "Fin Account Type"
        }, {
            "name" : "statusId",
            "title" : "Status"
        }, {
            "name" : "finAccountName",
            "title" : "Fin Account Name"
        }, {
            "name" : "finAccountCode",
            "title" : "Fin Account Code"
        }, {
            "name" : "finAccountPin",
            "title" : "Fin Account Pin"
        }, {
            "name" : "currencyUomId",
            "title" : "Currency"
        }, {
            "name" : "organizationPartyId",
            "title" : "Organization Party ID"
        }, {
            "name" : "ownerPartyId",
            "title" : "Owner Party ID"
        }, {
            "name" : "postToGlAccountId",
            "title" : "Post To Gl Account ID"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "isRefundable",
            "title" : "Is Refundable"
        }, {
            "name" : "replenishPaymentId",
            "title" : "Replenish Payment ID"
        }, {
            "name" : "replenishLevel",
            "title" : "Replenish Level"
        }, {
            "name" : "actualBalance",
            "title" : "Actual Balance"
        }, {
            "name" : "availableBalance",
            "title" : "Available Balance"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "ListCustomerFinAccounts",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Fin Account ID",
            "type" : "HYPERLINK",
            "target" : "EditFinAccount",
            "name" : "finAccountId",
            "width" : "",
            "parameterList" : [ {
            "name" : "finAccountId"
            } ],
            "style" : "",
            "id" : "ListFinAccounts_finAccountId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "finAccountTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListFinAccounts_finAccountTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "ListFinAccounts_statusId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Fin Account Name",
            "type" : "HYPERLINK",
            "target" : "EditFinAccount",
            "name" : "finAccountName",
            "width" : "",
            "parameterList" : [ {
            "name" : "finAccountId"
            } ],
            "style" : "",
            "id" : "ListFinAccounts_finAccountName",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "finAccountCode",
            "description" : "",
            "style" : "",
            "id" : "ListFinAccounts_finAccountCode",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "finAccountPin",
            "description" : "",
            "style" : "",
            "id" : "ListFinAccounts_finAccountPin",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "currencyUomId",
            "description" : "",
            "style" : "",
            "id" : "ListFinAccounts_currencyUomId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Organization Party ID",
            "type" : "HYPERLINK",
            "target" : "/partymgr/control/viewprofile",
            "name" : "organizationPartyId",
            "width" : "",
            "parameterList" : [ {
            "fromField" : {
                "isEmpty" : false,
                "original" : "organizationPartyId",
                "bracketedOriginal" : "${organizationPartyId}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "organizationPartyId"
            },
            "name" : "partyId"
            } ],
            "style" : "",
            "id" : "ListFinAccounts_organizationPartyId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Owner Party ID",
            "type" : "HYPERLINK",
            "target" : "/partymgr/control/viewprofile",
            "name" : "ownerPartyId",
            "width" : "",
            "parameterList" : [ {
            "fromField" : {
                "isEmpty" : false,
                "original" : "ownerPartyId",
                "bracketedOriginal" : "${ownerPartyId}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "ownerPartyId"
            },
            "name" : "partyId"
            } ],
            "style" : "",
            "id" : "ListFinAccounts_ownerPartyId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "postToGlAccountId",
            "description" : "",
            "style" : "",
            "id" : "ListFinAccounts_postToGlAccountId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListFinAccounts_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListFinAccounts_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "isRefundable",
            "description" : "",
            "style" : "",
            "id" : "ListFinAccounts_isRefundable",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "replenishPaymentId",
            "description" : "",
            "style" : "",
            "id" : "ListFinAccounts_replenishPaymentId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "replenishLevel",
            "description" : "",
            "style" : "",
            "id" : "ListFinAccounts_replenishLevel",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "actualBalance",
            "description" : "",
            "style" : "",
            "id" : "ListFinAccounts_actualBalance",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "availableBalance",
            "description" : "",
            "style" : "",
            "id" : "ListFinAccounts_availableBalance",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "finAccountId"
            } ],
            "id" : "ListFinAccounts_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "deleteFinAccount"
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId", "name", "comments", "externalId", "statusId" ]
        } ],
        "formName" : "ViewPartyPerson",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "partyId",
            "title" : "Party Id",
            "action" : "",
            "id" : "ViewPartyPerson_partyId",
            "type" : "DISPLAY",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "name",
            "title" : "Name",
            "action" : "",
            "id" : "ViewPartyPerson_name",
            "type" : "DISPLAY",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "comments",
            "title" : "Comments",
            "action" : "",
            "id" : "ViewPartyPerson_comments",
            "type" : "DISPLAY",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "externalId",
            "action" : "",
            "id" : "ViewPartyPerson_externalId",
            "type" : "DISPLAY",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "statusId",
            "action" : "",
            "id" : "ViewPartyPerson_statusId",
            "type" : "DISPLAY_ENTITY",
            "event" : "",
            "value" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ 
            {
                "fieldSetName" : "Default",
                "fields" : [ "contactMechTypeId", "contactMechId", "contactMechPurposeTypeId",  "removeLink", "updateLink" ]
            },
            {
                "fieldSetName" : "Detail",
                "fields" : ["attName", "address1", "address2", "city", "stateProvinceGeoId", "postalCode", "countryGeoId", "fromDate", "thruDate",]
            } 
        ],
        "columns" : [ {
            "name" : "contactMechPurposeTypeId",
            "title" : "Contact Purpose"
        }, {
            "name" : "attName",
            "title" : "Attention"
        }, {
            "name" : "address1",
            "title" : "Address 1"
        }, {
            "name" : "address2",
            "title" : "Address 2"
        }, {
            "name" : "city",
            "title" : "City"
        }, {
            "name" : "stateProvinceGeoId",
            "title" : "Province/State"
        }, {
            "name" : "postalCode",
            "title" : "Postal Code"
        }, {
            "name" : "countryGeoId",
            "title" : "Country"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Effective Through"
        }, {
            "name" : "removeLink",
            "title" : "Remove"
        }, {
            "name" : "updateLink",
            "title" : "Update"
        } ],
        "formName" : "CustomerPostalAddress",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "partyId",
            "action" : "",
            "id" : "CustomerPostalAddress_partyId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "10000"
        }, {
            "conditionGroup" : "",
            "name" : "contactMechTypeId",
            "action" : "",
            "id" : "CustomerPostalAddress_contactMechTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "contactMechId",
            "action" : "",
            "id" : "CustomerPostalAddress_contactMechId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contactMechPurposeTypeId",
            "description" : "",
            "style" : "",
            "id" : "CustomerPostalAddress_contactMechPurposeTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "attName",
            "description" : "",
            "style" : "",
            "id" : "CustomerPostalAddress_attName",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "address1",
            "description" : "",
            "style" : "",
            "id" : "CustomerPostalAddress_address1",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "address2",
            "description" : "",
            "style" : "",
            "id" : "CustomerPostalAddress_address2",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "city",
            "description" : "",
            "style" : "",
            "id" : "CustomerPostalAddress_city",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "stateProvinceGeoId",
            "description" : "",
            "style" : "",
            "id" : "CustomerPostalAddress_stateProvinceGeoId",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "postalCode",
            "description" : "",
            "style" : "",
            "id" : "CustomerPostalAddress_postalCode",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "countryGeoId",
            "description" : "",
            "style" : "",
            "id" : "CustomerPostalAddress_countryGeoId",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "CustomerPostalAddress_fromDate",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "CustomerPostalAddress_thruDate",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        },
        {
            "name" : "details",
            "description" : "",
            "style" : "",
            "id" : "CustomerPostalAddress_details",
            "title" : "Details",
            "type" : "COMPOSITE",
            "innerFields":[
                {
                    "name" : "attName",
                    "title" : "Attention"
                }, {
                    "name" : "address1",
                    "title" : "Address 1"
                }, {
                    "name" : "address2",
                    "title" : "Address 2"
                }, {
                    "name" : "city",
                    "title" : "City"
                }, {
                    "name" : "stateProvinceGeoId",
                    "title" : "Province/State"
                }, {
                    "name" : "postalCode",
                    "title" : "Postal Code"
                }, {
                    "name" : "countryGeoId",
                    "title" : "Country"
                }, {
                    "name" : "fromDate",
                    "title" : "From Date"
                }, {
                    "name" : "thruDate",
                    "title" : "Effective Through"
                }
            ]
        }, 
        {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Remove",
            "title" : "Remove",
            "type" : "HYPERLINK",
            "target" : "deleteContactMech",
            "name" : "removeLink",
            "width" : "",
            "parameterList" : [ {
            "name" : "partyId"
            }, {
            "name" : "contactMechId"
            } ],
            "style" : "",
            "id" : "CustomerPostalAddress_removeLink",
            "imageTitle" : "",
            "parameterMap" : {
            "partyId" : "10000"
            },
            "height" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Select",
            "title" : "Update",
            "type" : "HYPERLINK",
            "target" : "editcontactmech",
            "name" : "updateLink",
            "width" : "",
            "parameterList" : [ {
            "name" : "partyId"
            }, {
            "name" : "contactMechId"
            } ],
            "style" : "",
            "id" : "CustomerPostalAddress_updateLink",
            "imageTitle" : "",
            "parameterMap" : {
            "partyId" : "10000"
            },
            "height" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "contactMechTypeId", "contactMechId", "contactMechPurposeTypeId", "areaCode", "countryCode", "contactNumber", "fromDate", "thruDate", "removeLink", "updateLink" ]
        } ],
        "columns" : [ {
            "name" : "contactMechPurposeTypeId",
            "title" : "Purpose"
        }, {
            "name" : "areaCode",
            "title" : "areaCode"
        }, {
            "name" : "countryCode",
            "title" : "countryCode"
        }, {
            "name" : "contactNumber",
            "title" : "contactNumber"
        }, {
            "name" : "fromDate",
            "title" : "fromDate"
        }, {
            "name" : "thruDate",
            "title" : "thruDate"
        }, {
            "name" : "removeLink",
            "title" : "Remove"
        }, {
            "name" : "updateLink",
            "title" : "Update"
        } ],
        "formName" : "CustomerTelecomNumber",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "partyId",
            "action" : "",
            "id" : "CustomerTelecomNumber_partyId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "10000"
        }, {
            "conditionGroup" : "",
            "name" : "contactMechTypeId",
            "action" : "",
            "id" : "CustomerTelecomNumber_contactMechTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "contactMechId",
            "action" : "",
            "id" : "CustomerTelecomNumber_contactMechId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contactMechPurposeTypeId",
            "description" : "",
            "style" : "",
            "id" : "CustomerTelecomNumber_contactMechPurposeTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "name" : "details",
            "title": "Details",
            "type":"COMPOSITE",
            "innerFields":[
                {
                    "name" : "areaCode",
                    "title" : "Area Code"
                }, {
                    "name" : "countryCode",
                    "title" : "Country Code"
                }, {
                    "name" : "contactNumber",
                    "title" : "Contact Number"
                }, {
                    "name" : "fromDate",
                    "title" : "From Date"
                }, {
                    "name" : "thruDate",
                    "title" : "Thru Date"
                }
            ]
        },{
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "areaCode",
            "description" : "",
            "style" : "",
            "id" : "CustomerTelecomNumber_areaCode",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "countryCode",
            "description" : "",
            "style" : "",
            "id" : "CustomerTelecomNumber_countryCode",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contactNumber",
            "description" : "",
            "style" : "",
            "id" : "CustomerTelecomNumber_contactNumber",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "CustomerTelecomNumber_fromDate",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "CustomerTelecomNumber_thruDate",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Remove",
            "title" : "Remove",
            "type" : "HYPERLINK",
            "target" : "deleteContactMech",
            "name" : "removeLink",
            "width" : "",
            "parameterList" : [ {
            "name" : "partyId"
            }, {
            "name" : "contactMechId"
            } ],
            "style" : "",
            "id" : "CustomerTelecomNumber_removeLink",
            "imageTitle" : "",
            "parameterMap" : {
            "partyId" : "10000"
            },
            "height" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Select",
            "title" : "Update",
            "type" : "HYPERLINK",
            "target" : "editcontactmech",
            "name" : "updateLink",
            "width" : "",
            "parameterList" : [ {
            "name" : "partyId"
            }, {
            "name" : "contactMechId"
            } ],
            "style" : "",
            "id" : "CustomerTelecomNumber_updateLink",
            "imageTitle" : "",
            "parameterMap" : {
            "partyId" : "10000"
            },
            "height" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "contactMechTypeId", "contactMechId", "contactMechPurposeTypeId", "infoString", "fromDate", "thruDate", "removeLink", "updateLink" ]
        } ],
        "columns" : [ {
            "name" : "contactMechPurposeTypeId",
            "title" : "Purpose"
        }, {
            "name" : "infoString",
            "title" : "Info"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Thru Date"
        }, {
            "name" : "removeLink",
            "title" : "Remove"
        }, {
            "name" : "updateLink",
            "title" : "Update"
        } ],
        "formName" : "CustomerEmailAddress",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "partyId",
            "action" : "",
            "id" : "CustomerEmailAddress_partyId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "10000"
        }, {
            "conditionGroup" : "",
            "name" : "contactMechTypeId",
            "action" : "",
            "id" : "CustomerEmailAddress_contactMechTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "contactMechId",
            "action" : "",
            "id" : "CustomerEmailAddress_contactMechId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contactMechPurposeTypeId",
            "description" : "",
            "style" : "",
            "id" : "CustomerEmailAddress_contactMechPurposeTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "infoString",
            "description" : "",
            "style" : "",
            "id" : "CustomerEmailAddress_infoString",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "CustomerEmailAddress_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "CustomerEmailAddress_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Remove",
            "title" : "Remove",
            "type" : "HYPERLINK",
            "target" : "deleteContactMech",
            "name" : "removeLink",
            "width" : "",
            "parameterList" : [ {
            "name" : "partyId"
            }, {
            "name" : "contactMechId"
            } ],
            "style" : "",
            "id" : "CustomerEmailAddress_removeLink",
            "imageTitle" : "",
            "parameterMap" : {
            "partyId" : "10000"
            },
            "height" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Select",
            "title" : "Update",
            "type" : "HYPERLINK",
            "target" : "editcontactmech",
            "name" : "updateLink",
            "width" : "",
            "parameterList" : [ {
            "name" : "partyId"
            }, {
            "name" : "contactMechId"
            } ],
            "style" : "",
            "id" : "CustomerEmailAddress_updateLink",
            "imageTitle" : "",
            "parameterMap" : {
            "partyId" : "10000"
            },
            "height" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "paymentMethodId", "fromDate", "paymentMethodTypeId", "firstNameOnCard", "lastNameOnCard", "middleNameOnCard", "companyNameOnCard", "expireDate", "cardNumber", "cardType" ]
        } ],
        "columns" : [ {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "paymentMethodId",
            "title" : "Payment Method ID"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "paymentMethodTypeId",
            "title" : "Payment Method Type"
        }, {
            "name" : "firstNameOnCard",
            "title" : "First Name Card"
        }, {
            "name" : "lastNameOnCard",
            "title" : "Last Name Card"
        }, {
            "name" : "middleNameOnCard",
            "title" : "Middle Name Card"
        }, {
            "name" : "companyNameOnCard",
            "title" : "Company Name Card"
        }, {
            "name" : "expireDate",
            "title" : "Expire Date"
        }, {
            "name" : "cardNumber",
            "title" : "Card Number"
        }, {
            "name" : "cardType",
            "title" : "Card Type"
        } ],
        "formName" : "CustomerCreditCardPaymentMethods",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "details",
            "description" : "",
            "style" : "",
            "id" : "CustomerCreditCardPaymentMethods_description",
            "title" : "Card Details",
            "type" : "COMPOSITE",
            "innerFields":[
                {
                    "name" : "fromDate",
                    "title" : "From Date"
                }, {
                    "name" : "firstNameOnCard",
                    "title" : "First Name Card"
                }, {
                    "name" : "lastNameOnCard",
                    "title" : "Last Name Card"
                }, {
                    "name" : "middleNameOnCard",
                    "title" : "Middle Name Card"
                }, {
                    "name" : "companyNameOnCard",
                    "title" : "Company Name Card"
                }, {
                    "name" : "expireDate",
                    "title" : "Expire Date"
                }, {
                    "name" : "cardNumber",
                    "title" : "Card Number"
                }, {
                    "name" : "cardType",
                    "title" : "Card Type"
                }
            ],
            "imageLocation" : "" 
        },{
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "CustomerCreditCardPaymentMethods_description",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "paymentMethodId",
            "description" : "",
            "style" : "",
            "id" : "CustomerCreditCardPaymentMethods_paymentMethodId",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "CustomerCreditCardPaymentMethods_fromDate",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "paymentMethodTypeId",
            "description" : "",
            "style" : "",
            "id" : "CustomerCreditCardPaymentMethods_paymentMethodTypeId",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "firstNameOnCard",
            "description" : "",
            "style" : "",
            "id" : "CustomerCreditCardPaymentMethods_firstNameOnCard",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "lastNameOnCard",
            "description" : "",
            "style" : "",
            "id" : "CustomerCreditCardPaymentMethods_lastNameOnCard",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "middleNameOnCard",
            "description" : "",
            "style" : "",
            "id" : "CustomerCreditCardPaymentMethods_middleNameOnCard",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "companyNameOnCard",
            "description" : "",
            "style" : "",
            "id" : "CustomerCreditCardPaymentMethods_companyNameOnCard",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "expireDate",
            "description" : "",
            "style" : "",
            "id" : "CustomerCreditCardPaymentMethods_expireDate",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "cardNumber",
            "description" : "",
            "style" : "",
            "id" : "CustomerCreditCardPaymentMethods_cardNumber",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "cardType",
            "description" : "",
            "style" : "",
            "id" : "CustomerCreditCardPaymentMethods_cardType",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "paymentMethodId", "fromDate", "paymentMethodTypeId" ]
        } ],
        "columns" : [ {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "paymentMethodId",
            "title" : "Payment Method ID"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "paymentMethodTypeId",
            "title" : "Payment Method Type"
        } ],
        "formName" : "CustomerCheckingPaymentMethods",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "CustomerCheckingPaymentMethods_description",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "paymentMethodId",
            "description" : "",
            "style" : "",
            "id" : "CustomerCheckingPaymentMethods_paymentMethodId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "CustomerCheckingPaymentMethods_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "paymentMethodTypeId",
            "description" : "COMPANY_CHECK",
            "style" : "",
            "id" : "CustomerCheckingPaymentMethods_paymentMethodTypeId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId", "partyId", "salutation", "firstName", "middleName", "lastName", "personalTitle", "suffix", "nickname", "firstNameLocal", "middleNameLocal", "lastNameLocal", "otherLocal", "memberId", "gender", "birthDate", "deceasedDate", "height", "weight", "mothersMaidenName", "oldMaritalStatus", "maritalStatusEnumId", "socialSecurityNumber", "passportNumber", "passportExpireDate", "totalYearsWorkExperience", "comments", "employmentStatusEnumId", "residenceStatusEnumId", "occupation", "yearsWithEmployer", "monthsWithEmployer", "existingCustomer", "cardId", "preferredCurrencyUomId", "description", "externalId", "statusId", "statusId", "statusId", "submitButton", "cancelLink" ]
        } ],
        "formName" : "EditPerson",
        "altTarget" : [ {
            "useWhen" : "personInfo==null",
            "targetExdr" : {
            "chars" : "createPerson",
            "hint" : 20,
            "empty" : false,
            "original" : "createPerson"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "statusId",
            "action" : "",
            "id" : "EditPerson_statusId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Party ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "partyId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_partyId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Salutation",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "salutation",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_salutation",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "required",
            "title" : "First name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "firstName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_firstName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Middle Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "middleName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_middleName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "required",
            "title" : "Last name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "lastName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_lastName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Personal Title",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "personalTitle",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_personalTitle",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Suffix",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "suffix",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_suffix",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Nickname",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "nickname",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_nickname",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "First Name Local",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "firstNameLocal",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_firstNameLocal",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Middle Name Local",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "middleNameLocal",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_middleNameLocal",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Last Name Local",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "lastNameLocal",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_lastNameLocal",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Other Local",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "otherLocal",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_otherLocal",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Member ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "memberId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_memberId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Gender",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditPerson",
            "options" : [ {
            "description" : "Male",
            "key" : "M"
            }, {
            "description" : "Female",
            "key" : "F"
            } ],
            "disabled" : "false",
            "id" : "EditPerson_gender",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "gender",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "true",
            "ampmName" : "",
            "className" : "",
            "title" : "Birth Date",
            "type" : "DATE_TIME",
            "dateType" : "date",
            "defaultDateTimeString" : "2024-10-04",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditPerson",
            "timeDropdownParamName" : "birthDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditPerson_birthDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "10",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "10",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "birthDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "true",
            "ampmName" : "",
            "className" : "",
            "title" : "Deceased Date",
            "type" : "DATE_TIME",
            "dateType" : "date",
            "defaultDateTimeString" : "2024-10-04",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditPerson",
            "timeDropdownParamName" : "deceasedDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditPerson_deceasedDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "10",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "10",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "deceasedDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Height",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "height",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_height",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Weight",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "weight",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_weight",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Mothers Maiden Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "mothersMaidenName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_mothersMaidenName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Old Marital Status",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditPerson",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "EditPerson_oldMaritalStatus",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "first-in-list",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "oldMaritalStatus",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Marital Status Enum ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditPerson",
            "options" : [ {
            "description" : "Single []",
            "key" : "SINGLE"
            }, {
            "description" : "Married []",
            "key" : "MARRIED"
            } ],
            "disabled" : "false",
            "id" : "EditPerson_maritalStatusEnumId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "maritalStatusEnumId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Social Security Number",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "socialSecurityNumber",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_socialSecurityNumber",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Passport Number",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "passportNumber",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_passportNumber",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "true",
            "ampmName" : "",
            "className" : "",
            "title" : "Passport Expire Date",
            "type" : "DATE_TIME",
            "dateType" : "date",
            "defaultDateTimeString" : "2024-10-04",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditPerson",
            "timeDropdownParamName" : "passportExpireDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditPerson_passportExpireDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "10",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "10",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "passportExpireDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Total Years Work Experience",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "totalYearsWorkExperience",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_totalYearsWorkExperience",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Comments",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "comments",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_comments",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Employment Status Enum ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditPerson",
            "options" : [ {
            "description" : "Full-time Employed [FULLTIME]",
            "key" : "EMPS_FULLTIME"
            }, {
            "description" : "Part-time Employed [PARTTIME]",
            "key" : "EMPS_PARTTIME"
            }, {
            "description" : "Self Employed [SELF]",
            "key" : "EMPS_SELF"
            }, {
            "description" : "House-Person [HOUSE]",
            "key" : "EMPS_HOUSE"
            }, {
            "description" : "Retired [RETIRED]",
            "key" : "EMPS_RETIRED"
            }, {
            "description" : "Student [STUDENT]",
            "key" : "EMPS_STUDENT"
            }, {
            "description" : "Unemployed [UNEMP]",
            "key" : "EMPS_UNEMP"
            } ],
            "disabled" : "false",
            "id" : "EditPerson_employmentStatusEnumId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "employmentStatusEnumId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Residence Status Enum ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditPerson",
            "options" : [ {
            "description" : "Own Home [OWN]",
            "key" : "PRESS_OWN"
            }, {
            "description" : "Private Tenant [PVT_TENANT]",
            "key" : "PRESS_PVT_TENANT"
            }, {
            "description" : "Public Tenant [PUB_TENANT]",
            "key" : "PRESS_PUB_TENANT"
            }, {
            "description" : "With Parents [PARENTS]",
            "key" : "PRESS_PARENTS"
            } ],
            "disabled" : "false",
            "id" : "EditPerson_residenceStatusEnumId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "residenceStatusEnumId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Occupation",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "occupation",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_occupation",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Years With Employer",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "yearsWithEmployer",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_yearsWithEmployer",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Months With Employer",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "monthsWithEmployer",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_monthsWithEmployer",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Existing Customer",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditPerson",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "EditPerson_existingCustomer",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "existingCustomer",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Card ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "cardId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_cardId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Preferred Currency Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditPerson",
            "options" : [ {
            "description" : "Afghani - AFN",
            "key" : "AFN"
            }, {
            "description" : "Albanian Lek - ALL",
            "key" : "ALL"
            }, {
            "description" : "Algerian Dinar - DZD",
            "key" : "DZD"
            }, {
            "description" : "American Dollar - USD",
            "key" : "USD"
            }, {
            "description" : "Angolan Kwanza - AOA",
            "key" : "AOA"
            }, {
            "description" : "Argentina Peso - ARS",
            "key" : "ARS"
            }, {
            "description" : "Armenian Dram - AMD",
            "key" : "AMD"
            }, {
            "description" : "Aruban Guilder - AWG",
            "key" : "AWG"
            }, {
            "description" : "Australian Dollar - AUD",
            "key" : "AUD"
            }, {
            "description" : "Azerbaijan Manat - AZN",
            "key" : "AZN"
            }, {
            "description" : "Bahaman Dollar - BSD",
            "key" : "BSD"
            }, {
            "description" : "Bahrain Dinar - BHD",
            "key" : "BHD"
            }, {
            "description" : "Bangladesh Taka - BDT",
            "key" : "BDT"
            }, {
            "description" : "Barbados Dollar - BBD",
            "key" : "BBD"
            }, {
            "description" : "Belize Dollar - BZD",
            "key" : "BZD"
            }, {
            "description" : "Belorussian Ruble - BYN",
            "key" : "BYN"
            }, {
            "description" : "Benin C.f.A. Franc - XOF",
            "key" : "XOF"
            }, {
            "description" : "Bermudan Dollar - BMD",
            "key" : "BMD"
            }, {
            "description" : "Bolivian Boliviano - BOB",
            "key" : "BOB"
            }, {
            "description" : "Botswana Pula - BWP",
            "key" : "BWP"
            }, {
            "description" : "Brazilian Real - BRL",
            "key" : "BRL"
            }, {
            "description" : "British Pound - GBP",
            "key" : "GBP"
            }, {
            "description" : "Brunei Dollar - BND",
            "key" : "BND"
            }, {
            "description" : "Bulgarian Lev - BGN",
            "key" : "BGN"
            }, {
            "description" : "Burundi Franc - BIF",
            "key" : "BIF"
            }, {
            "description" : "Cambodian Riel - KHR",
            "key" : "KHR"
            }, {
            "description" : "Canadian Dollar - CAD",
            "key" : "CAD"
            }, {
            "description" : "Cape Verde Escudo - CVE",
            "key" : "CVE"
            }, {
            "description" : "Cayman Dollar - KYD",
            "key" : "KYD"
            }, {
            "description" : "Chilean Peso - CLP",
            "key" : "CLP"
            }, {
            "description" : "China - CNY",
            "key" : "CNY"
            }, {
            "description" : "Colombian Peso - COP",
            "key" : "COP"
            }, {
            "description" : "Comoros Franc - KMF",
            "key" : "KMF"
            }, {
            "description" : "Convertible Marks - BAM",
            "key" : "BAM"
            }, {
            "description" : "Costa Rica Colon - CRC",
            "key" : "CRC"
            }, {
            "description" : "Croatian Kuna - HRK",
            "key" : "HRK"
            }, {
            "description" : "Cuban Peso - CUP",
            "key" : "CUP"
            }, {
            "description" : "Czech Krona - CZK",
            "key" : "CZK"
            }, {
            "description" : "Danish Krone - DKK",
            "key" : "DKK"
            }, {
            "description" : "Djibouti Franc - DJF",
            "key" : "DJF"
            }, {
            "description" : "Dominican Peso - DOP",
            "key" : "DOP"
            }, {
            "description" : "East Carribean Dollar - XCD",
            "key" : "XCD"
            }, {
            "description" : "Egyptian Pound - EGP",
            "key" : "EGP"
            }, {
            "description" : "El Salvador Colon - SVC",
            "key" : "SVC"
            }, {
            "description" : "Ethiopian Birr - ETB",
            "key" : "ETB"
            }, {
            "description" : "Euro - EUR",
            "key" : "EUR"
            }, {
            "description" : "Falkland Pound - FKP",
            "key" : "FKP"
            }, {
            "description" : "Fiji Dollar - FJD",
            "key" : "FJD"
            }, {
            "description" : "Gabon C.f.A Franc - XAF",
            "key" : "XAF"
            }, {
            "description" : "Gambian Dalasi - GMD",
            "key" : "GMD"
            }, {
            "description" : "Ghanian Cedi - GHS",
            "key" : "GHS"
            }, {
            "description" : "Gibraltar Pound - GIP",
            "key" : "GIP"
            }, {
            "description" : "Guatemalan Quedzal - GTQ",
            "key" : "GTQ"
            }, {
            "description" : "Guinea Franc - GNF",
            "key" : "GNF"
            }, {
            "description" : "Guyanese Dollar - GYD",
            "key" : "GYD"
            }, {
            "description" : "Haitian Gourde - HTG",
            "key" : "HTG"
            }, {
            "description" : "Honduran Lempira - HNL",
            "key" : "HNL"
            }, {
            "description" : "Hong Kong Dollar - HKD",
            "key" : "HKD"
            }, {
            "description" : "Hungarian forint - HUF",
            "key" : "HUF"
            }, {
            "description" : "Iceland Krona - ISK",
            "key" : "ISK"
            }, {
            "description" : "Indian Rupee - INR",
            "key" : "INR"
            }, {
            "description" : "Indonesian Rupiah - IDR",
            "key" : "IDR"
            }, {
            "description" : "Iranian Rial - IRR",
            "key" : "IRR"
            }, {
            "description" : "Iraqui Dinar - IQD",
            "key" : "IQD"
            }, {
            "description" : "Jamaican Dollar - JMD",
            "key" : "JMD"
            }, {
            "description" : "Japanese Yen - JPY",
            "key" : "JPY"
            }, {
            "description" : "Jordanian Dinar - JOD",
            "key" : "JOD"
            }, {
            "description" : "Kazakhstani Tenge - KZT",
            "key" : "KZT"
            }, {
            "description" : "Kenyan Shilling - KES",
            "key" : "KES"
            }, {
            "description" : "Kirghizstan Som - KGS",
            "key" : "KGS"
            }, {
            "description" : "Kuwaiti Dinar - KWD",
            "key" : "KWD"
            }, {
            "description" : "Laotian Kip - LAK",
            "key" : "LAK"
            }, {
            "description" : "Lari - GEL",
            "key" : "GEL"
            }, {
            "description" : "Lebanese Pound - LBP",
            "key" : "LBP"
            }, {
            "description" : "Leone - SLL",
            "key" : "SLL"
            }, {
            "description" : "Lesotho Loti - LSL",
            "key" : "LSL"
            }, {
            "description" : "Liberian Dollar - LRD",
            "key" : "LRD"
            }, {
            "description" : "Libyan Dinar - LYD",
            "key" : "LYD"
            }, {
            "description" : "Macao Pataca - MOP",
            "key" : "MOP"
            }, {
            "description" : "Malagascy Ariary - MGA",
            "key" : "MGA"
            }, {
            "description" : "Malawi Kwacha - MWK",
            "key" : "MWK"
            }, {
            "description" : "Malaysian Ringgit - MYR",
            "key" : "MYR"
            }, {
            "description" : "Maldive Rufiyaa - MVR",
            "key" : "MVR"
            }, {
            "description" : "Mauritanian Ouguiya - MRU",
            "key" : "MRU"
            }, {
            "description" : "Mauritius Rupee - MUR",
            "key" : "MUR"
            }, {
            "description" : "Mexican Peso - MXN",
            "key" : "MXN"
            }, {
            "description" : "Moldavian Lei - MDL",
            "key" : "MDL"
            }, {
            "description" : "Mongolian Tugrik - MNT",
            "key" : "MNT"
            }, {
            "description" : "Moroccan Dirham - MAD",
            "key" : "MAD"
            }, {
            "description" : "Mozambique Metical - MZN",
            "key" : "MZN"
            }, {
            "description" : "Nepalese Rupee - NPR",
            "key" : "NPR"
            }, {
            "description" : "New Israeli Shekel - ILS",
            "key" : "ILS"
            }, {
            "description" : "New Taiwan Dollar - TWD",
            "key" : "TWD"
            }, {
            "description" : "New Zaire - ZRN",
            "key" : "ZRN"
            }, {
            "description" : "New Zealand Dollar - NZD",
            "key" : "NZD"
            }, {
            "description" : "Nicaraguan Cordoba - NIO",
            "key" : "NIO"
            }, {
            "description" : "Nigerian Naira - NGN",
            "key" : "NGN"
            }, {
            "description" : "North Korean Won - KPW",
            "key" : "KPW"
            }, {
            "description" : "Norwegian Krone - NOK",
            "key" : "NOK"
            }, {
            "description" : "Omani Rial - OMR",
            "key" : "OMR"
            }, {
            "description" : "Pakistan Rupee - PKR",
            "key" : "PKR"
            }, {
            "description" : "Panamanian Balboa - PAB",
            "key" : "PAB"
            }, {
            "description" : "Papua New Guinea Kina - PGK",
            "key" : "PGK"
            }, {
            "description" : "Paraguayan Guarani - PYG",
            "key" : "PYG"
            }, {
            "description" : "Peruvian Sol - PEN",
            "key" : "PEN"
            }, {
            "description" : "Philippino Peso - PHP",
            "key" : "PHP"
            }, {
            "description" : "Polish Zloty - PLN",
            "key" : "PLN"
            }, {
            "description" : "Qatar Riyal - QAR",
            "key" : "QAR"
            }, {
            "description" : "Romanian Leu - RON",
            "key" : "RON"
            }, {
            "description" : "Russian Rouble - RUB",
            "key" : "RUB"
            }, {
            "description" : "Rwanda Franc - RWF",
            "key" : "RWF"
            }, {
            "description" : "Samoan Tala - WST",
            "key" : "WST"
            }, {
            "description" : "Sao Tome and Principe Dobra - STN",
            "key" : "STN"
            }, {
            "description" : "Saudi Riyal - SAR",
            "key" : "SAR"
            }, {
            "description" : "Seychelles Rupee - SCR",
            "key" : "SCR"
            }, {
            "description" : "Singapore Dollar - SGD",
            "key" : "SGD"
            }, {
            "description" : "Solomon Islands Dollar - SBD",
            "key" : "SBD"
            }, {
            "description" : "Somalian Shilling - SOS",
            "key" : "SOS"
            }, {
            "description" : "South African Rand - ZAR",
            "key" : "ZAR"
            }, {
            "description" : "South Korean Won - KRW",
            "key" : "KRW"
            }, {
            "description" : "South Sudanese Pound - SSP",
            "key" : "SSP"
            }, {
            "description" : "Sri Lankan Rupee - LKR",
            "key" : "LKR"
            }, {
            "description" : "St.Helena Pound - SHP",
            "key" : "SHP"
            }, {
            "description" : "Sudanese Pound - SDG",
            "key" : "SDG"
            }, {
            "description" : "Surinam Dollar - SRD",
            "key" : "SRD"
            }, {
            "description" : "Swaziland Lilangeni - SZL",
            "key" : "SZL"
            }, {
            "description" : "Swedish Krona - SEK",
            "key" : "SEK"
            }, {
            "description" : "Swiss Franc - CHF",
            "key" : "CHF"
            }, {
            "description" : "Syrian Pound - SYP",
            "key" : "SYP"
            }, {
            "description" : "Tadzhikistani Somoni - TJS",
            "key" : "TJS"
            }, {
            "description" : "Tanzanian Shilling - TZS",
            "key" : "TZS"
            }, {
            "description" : "Thailand Baht - THB",
            "key" : "THB"
            }, {
            "description" : "Tongan Pa\\'anga - TOP",
            "key" : "TOP"
            }, {
            "description" : "Trinidad and Tobago Dollar - TTD",
            "key" : "TTD"
            }, {
            "description" : "Tunisian Dinar - TND",
            "key" : "TND"
            }, {
            "description" : "Turkish Lira - TRY",
            "key" : "TRY"
            }, {
            "description" : "Turkmenistani Manat - TMT",
            "key" : "TMT"
            }, {
            "description" : "Ugandan Shilling - UGX",
            "key" : "UGX"
            }, {
            "description" : "Ukrainian Hryvnia - UAH",
            "key" : "UAH"
            }, {
            "description" : "United Arab Emirates Dirham - AED",
            "key" : "AED"
            }, {
            "description" : "Uruguay - UYU",
            "key" : "UYU"
            }, {
            "description" : "Uruguay Peso en Unidades Indexadas (UI) - UYI",
            "key" : "UYI"
            }, {
            "description" : "Vanuatu Vatu - VUV",
            "key" : "VUV"
            }, {
            "description" : "Venezuelan Bolívar Soberano - VES",
            "key" : "VES"
            }, {
            "description" : "Vietnamese Dong - VND",
            "key" : "VND"
            }, {
            "description" : "West Indian Guilder - ANG",
            "key" : "ANG"
            }, {
            "description" : "Yemeni Ryal - YER",
            "key" : "YER"
            }, {
            "description" : "Zambian Kwacha - ZMW",
            "key" : "ZMW"
            }, {
            "description" : "Zimbabwean Dollar - ZWL",
            "key" : "ZWL"
            } ],
            "disabled" : "false",
            "id" : "EditPerson_preferredCurrencyUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "preferredCurrencyUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "External ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "externalId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditPerson_externalId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditPerson",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "EditPerson_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Save",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "cancelLink",
            "alternate" : "",
            "description" : "Cancel/Done",
            "parameterList" : [ {
            "name" : "partyId"
            } ],
            "id" : "EditPerson_cancelLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : ""
        } ],
        "target" : "updatePerson"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "description", "paymentMethodId", "fromDate", "paymentMethodTypeId", "accountNumber", "bankName", "routingNumber", "nameOnAccount", "companyNameOnAccount" ]
        } ],
        "columns" : [ {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "paymentMethodId",
            "title" : "Payment Method ID"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "paymentMethodTypeId",
            "title" : "Payment Method Type"
        }, {
            "name" : "accountNumber",
            "title" : "Account Number"
        }, {
            "name" : "bankName",
            "title" : "Bank Name"
        }, {
            "name" : "routingNumber",
            "title" : "Routing Number"
        }, {
            "name" : "nameOnAccount",
            "title" : "Account Name"
        }, {
            "name" : "companyNameOnAccount",
            "title" : "Account Name"
        } ],
        "formName" : "CustomerEftPaymentMethods",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "details",
            "title":"EFT Payment Method Details",
            "action" : "",
            "id" : "CustomerCheckingPaymentMethods_partyId",
            "type" : "COMPOSITE",
            "innerFields":[
                {
                    "name" : "fromDate",
                    "title" : "From Date"
                }, {
                    "name" : "accountNumber",
                    "title" : "Account Number"
                }, {
                    "name" : "bankName",
                    "title" : "Bank Name"
                }, {
                    "name" : "routingNumber",
                    "title" : "Routing Number"
                }, {
                    "name" : "nameOnAccount",
                    "title" : "Account Name"
                }, {
                    "name" : "companyNameOnAccount",
                    "title" : "Account Name"
                }
            ],
            "event" : "",
            "value" : "" 
        },{
            "conditionGroup" : "",
            "name" : "partyId",
            "action" : "",
            "id" : "CustomerCheckingPaymentMethods_partyId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "CustomerCheckingPaymentMethods_description",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "paymentMethodId",
            "description" : "",
            "style" : "",
            "id" : "CustomerCheckingPaymentMethods_paymentMethodId",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "CustomerCheckingPaymentMethods_fromDate",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "paymentMethodTypeId",
            "description" : "EFT_ACCOUNT",
            "style" : "",
            "id" : "CustomerCheckingPaymentMethods_paymentMethodTypeId",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "accountNumber",
            "description" : "",
            "style" : "",
            "id" : "CustomerCheckingPaymentMethods_accountNumber",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "bankName",
            "description" : "",
            "style" : "",
            "id" : "CustomerEftPaymentMethods_bankName",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "routingNumber",
            "description" : "",
            "style" : "",
            "id" : "CustomerEftPaymentMethods_routingNumber",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "nameOnAccount",
            "description" : "",
            "style" : "",
            "id" : "CustomerEftPaymentMethods_nameOnAccount",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "companyNameOnAccount",
            "description" : "",
            "style" : "",
            "id" : "CustomerEftPaymentMethods_companyNameOnAccount",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "accountLimit", "fromDate", "description", "accountBalance" ]
        } ],
        "columns" : [ {
            "name" : "billingAccountId",
            "title" : "Billing Account Id"
        }, {
            "name" : "accountLimit",
            "title" : "Account Limit"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "accountBalance",
            "title" : "Account Balance"
        } ],
        "formName" : "CustomerBillingPaymentMethods",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "details",
            "description" : "",
            "style" : "",
            "id" : "CustomerBillingPaymentMethods_billingAccountId",
            "title" : "Billing Account Details",
            "type" : "COMPOSITE",
            "innerFields":[
                {
                    "name" : "accountLimit",
                    "title" : "Account Limit"
                }, {
                    "name" : "fromDate",
                    "title" : "From Date"
                }, {
                    "name" : "description",
                    "title" : "Description"
                }, {
                    "name" : "accountBalance",
                    "title" : "Account Balance"
                } 
            ],
            "imageLocation" : ""
        },{
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "billingAccountId",
            "description" : "",
            "style" : "",
            "id" : "CustomerBillingPaymentMethods_billingAccountId",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "accountLimit",
            "description" : "",
            "style" : "",
            "id" : "CustomerBillingPaymentMethods_accountLimit",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "CustomerBillingPaymentMethods_fromDate",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "CustomerBillingPaymentMethods_description",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "accountBalance",
            "description" : "",
            "style" : "",
            "id" : "CustomerBillingPaymentMethods_accountBalance",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "monthsToInclude", "totalSubRemainingAmount" ]
        } ],
        "formName" : "CustomerLoyaltyPoints",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "totalOrders",
            "title" : "Orders",
            "action" : "",
            "id" : "CustomerLoyaltyPoints_totalOrders",
            "type" : "DISPLAY",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "monthsToInclude",
            "action" : "",
            "id" : "CustomerLoyaltyPoints_monthsToInclude",
            "type" : "DISPLAY",
            "event" : "",
            "title":"Months",
            "value" : "12"
        }, {
            "conditionGroup" : "",
            "name" : "totalSubRemainingAmount",
            "action" : "",
            "title" : "POints",
            "id" : "CustomerLoyaltyPoints_totalSubRemainingAmount",
            "type" : "DISPLAY",
            "event" : "",
            "value" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId", "partyIdentTypeDesc", "idValue", "delete", "submit" ]
        } ],
        "columns" : [ {
            "name" : "partyIdentTypeDesc",
            "title" : "Identification Type"
        }, {
            "name" : "idValue",
            "title" : "Value"
        }, {
            "name" : "delete",
            "title" : "Delete"
        }, {
            "name" : "submit",
            "title" : "CommonUpdate"
        } ],
        "formName" : "ListPartyIdentification",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "partyIdentificationTypeId",
            "action" : "",
            "id" : "ListPartyIdentification_partyIdentificationTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "partyId",
            "action" : "",
            "id" : "ListPartyIdentification_partyId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "10000"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyIdentTypeDesc",
            "description" : "",
            "style" : "",
            "id" : "ListPartyIdentification_partyIdentTypeDesc",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "details",
            "description" : "",
            "style" : "",
            "id" : "ListPartyIdentification_idValue",
            "title" : "Identity Details",
            "type" : "COMPOSITE",
            "innerFields":[
                {
                    "name" : "partyIdentTypeDesc",
                    "title" : "Identification Type"
                }, {
                    "name" : "idValue",
                    "title" : "Value"
                }
            ],
            "imageLocation" : ""
        },{
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "idValue",
            "description" : "",
            "style" : "",
            "id" : "ListPartyIdentification_idValue",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "CommonDelete",
            "title" : "Delete",
            "type" : "HYPERLINK",
            "target" : "deletePartyIdentification",
            "name" : "delete",
            "width" : "",
            "parameterList" : [ {
            "name" : "partyId"
            }, {
            "name" : "partyIdentificationTypeId"
            } ],
            "style" : "",
            "id" : "ListPartyIdentification_delete",
            "imageTitle" : "",
            "parameterMap" : {
            "partyId" : "10000"
            },
            "height" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ListPartyIdentification",
            "tabindex" : "",
            "name" : "submit",
            "className" : "",
            "id" : "ListPartyIdentification_submit",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "CommonUpdate",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyContentTypeId", "contentName", "mimeTypeId", "statusId", "fromDate", "deleteLink", "viewContentLink" ]
        } ],
        "columns" : [ {
            "name" : "partyContentTypeId",
            "title" : "Content Type"
        }, {
            "name" : "contentName",
            "title" : "Name"
        }, {
            "name" : "mimeTypeId",
            "title" : "Mime Type"
        }, {
            "name" : "statusId",
            "title" : "Status"
        }, {
            "name" : "fromDate",
            "title" : "From"
        }, {
            "name" : "deleteLink",
            "title" : " "
        }, {
            "name" : "viewContentLink",
            "title" : " "
        } ],
        "formName" : "PartyContentList",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "contentId",
            "action" : "",
            "id" : "PartyContentList_contentId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyContentTypeId",
            "description" : "",
            "style" : "",
            "id" : "PartyContentList_partyContentTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "name" : "contentDetails",
            "description" : "",
            "style" : "",
            "id" : "PartyContentList_partyContentTypeId",
            "title" : "Content Details",
            "type" : "COMPOSITE",
            "innerFields":[
                {
                    "name" : "contentName",
                    "title" : "Name"
                }, {
                    "name" : "mimeTypeId",
                    "title" : "Mime Type"
                }, {
                    "name" : "statusId",
                    "title" : "Status"
                }, {
                    "name" : "fromDate",
                    "title" : "From"
                }
            ] 
        },{
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contentName",
            "description" : "",
            "style" : "",
            "id" : "PartyContentList_contentName",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "mimeTypeId",
            "description" : "",
            "style" : "",
            "id" : "PartyContentList_mimeTypeId",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "PartyContentList_statusId",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "PartyContentList_fromDate",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Remove",
            "parameterList" : [ {
            "name" : "agreementItemSeqId"
            }, {
            "name" : "agreementId"
            } ],
            "id" : "PartyContentList_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "removeAgreementItem"
        }, {
            "image" : "",
            "width" : "",
            "name" : "viewContentLink",
            "alternate" : "",
            "description" : "View",
            "parameterList" : [ {
            "name" : "contentId"
            } ],
            "id" : "PartyContentList_viewContentLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "stream"
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "noteId", "noteName", "noteInfo", "noteDateTime", "noteParty" ]
        } ],
        "columns" : [ {
            "name" : "noteName",
            "title" : "Note Name"
        }, {
            "name" : "noteInfo",
            "title" : "Note"
        }, {
            "name" : "noteDateTime",
            "title" : "At"
        }, {
            "name" : "noteParty",
            "title" : "By"
        } ],
        "formName" : "CustomerNotes",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/PartyForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "targetPartyId",
            "action" : "",
            "id" : "CustomerNotes_targetPartyId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "noteId",
            "action" : "",
            "id" : "CustomerNotes_noteId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "name" : "noteDetails",
            "description" : "",
            "style" : "",
            "id" : "CustomerNotes_noteName",
            "title" : "Details",
            "type" : "COMPOSITE",
            "innerFields":[
                {
                    "name" : "noteName",
                    "title" : "Note Name"
                }, {
                    "name" : "noteInfo",
                    "title" : "Note"
                }, {
                    "name" : "noteDateTime",
                    "title" : "At"
                }, {
                    "name" : "noteParty",
                    "title" : "By"
                }
            ]
        },{
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "noteName",
            "description" : "",
            "style" : "",
            "id" : "CustomerNotes_noteName",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "noteInfo",
            "description" : "",
            "style" : "",
            "id" : "CustomerNotes_noteInfo",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "noteDateTime",
            "description" : "",
            "style" : "",
            "id" : "CustomerNotes_noteDateTime",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "noteParty",
            "description" : "",
            "style" : "",
            "id" : "CustomerNotes_noteParty",
            "title" : "",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""

    }
]